import { AlertCircle } from '@untitled-ui/icons-react';
import { type TFunctionNonStrict } from 'i18next';
import { Trans } from 'react-i18next';

import { getConfig } from '../config';
import { tGlobal, tNamespace } from '../services/translation';
import { Button } from './buttons/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogTitle } from './dialog';
import { FeaturedIcon } from './featured-icon';

const t = tNamespace('app.billing.general');

type ModalPaymentFailedProps = {
  open: boolean;
  onRetry: () => void;
  onOpenChange: (open: boolean) => void;
};

export function ModalPaymentFailed(props: ModalPaymentFailedProps) {
  const { open, onOpenChange, onRetry } = props;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent hasCloseButton>
        <FeaturedIcon icon={<AlertCircle />} color="red" size="md" className="m-auto mb-6" />
        <DialogTitle align="center">{t('paymentFailed')}</DialogTitle>
        <DialogDescription align="center">
          <Trans
            t={t as unknown as TFunctionNonStrict}
            i18nKey="paymentFailedDescriptionModal"
            components={[
              <a
                href={getConfig().urlHelp}
                target={'_blank'}
                rel="noopener noreferrer"
                key="link"
                className="text-branding-accent underline"
              ></a>,
            ]}
          />
        </DialogDescription>
        <DialogFooter>
          <Button
            size="xl"
            variant="outline"
            className="w-full"
            onClick={() => void onOpenChange(false)}
          >
            {tGlobal('cancel')}
          </Button>
          <Button size="xl" variant="accent" className="w-full" onClick={() => void onRetry()}>
            {tGlobal('retry')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
